import Immutable from 'immutable'

export const getPatientInsuranceCompanyId = (patient) => {
  if (!patient) return ''
  const ic = patient.get('insuranceCompany')
  if (!ic) return ''
  if (Immutable.Map.isMap(ic)) return ic.get('_id')
  return ic
}

export const buildPatientCopaidSessionsUpdate = (patient, copaidSessions) => ({
  ...patient.toJS(),
  insuranceCompany: getPatientInsuranceCompanyId(patient),
  copaidSessions,
})

export const appendCopaidSession = (patient, { amount, date }) => {
  const existingSessions = patient.get('copaidSessions', Immutable.List())
  return buildPatientCopaidSessionsUpdate(
    patient,
    existingSessions.concat([{ amount, date }]).toJS(),
  )
}

export const removeCopaidSession = (patient, sessionId) => {
  const updatedSessions = patient.get('copaidSessions', Immutable.List())
    .filter(session => session.get('_id') !== sessionId)
    .toJS()
  return buildPatientCopaidSessionsUpdate(patient, updatedSessions)
}
